<template>
  <div class="cloud-drive-list">
    <div class="header">
      <h1>我的共享云盘</h1>
    </div>

    <div class="content">
      <div v-if="loading" class="loading">加载中...</div>

      <div v-else-if="list.length === 0" class="empty">
        <p>暂无共享云盘</p>
      </div>

      <div v-else class="drive-grid">
        <div
          v-for="item in list"
          :key="item.id"
          class="drive-card"
          @click="goToFiles(item.id)"
        >
          <div class="drive-icon">📁</div>
          <h3>{{ item.name }}</h3>
          <p class="description">{{ item.description }}</p>
          <div class="meta">
            <span>加入时间：{{ formatDate(item.joined_at) }}</span>
          </div>
        </div>
      </div>

      <div v-if="pagination.total > pagination.per_page" class="pagination">
        <button
          @click="loadPage(pagination.current_page - 1)"
          :disabled="pagination.current_page === 1"
        >
          上一页
        </button>
        <span>{{ pagination.current_page }} / {{ pagination.last_page }}</span>
        <button
          @click="loadPage(pagination.current_page + 1)"
          :disabled="pagination.current_page === pagination.last_page"
        >
          下一页
        </button>
      </div>
    </div>

    <!-- Token 失效弹窗 -->
    <AuthModal :visible="showAuthModal" @relogin="handleRelogin" />
  </div>
</template>

<script>
import { fetchShareList } from '@/api/cloudDrive'
import AuthModal from '@/components/AuthModal.vue'
import authErrorHandler from '@/mixins/authErrorHandler'

export default {
  name: 'CloudDriveList',
  components: {
    AuthModal
  },
  mixins: [authErrorHandler],
  data() {
    return {
      loading: true,
      list: [],
      pagination: {
        current_page: 1,
        total: 0,
        per_page: 10,
        last_page: 1
      }
    }
  },
  async mounted() {
    await this.loadList()
  },
  methods: {
    async loadList(page = 1) {
      try {
        this.loading = true
        const result = await fetchShareList({ page, pageSize: 10 })
        this.list = result.data
        this.pagination = {
          current_page: result.current_page,
          total: result.total,
          per_page: result.per_page,
          last_page: result.last_page
        }
      } catch (err) {
        if (this.isAuthError(err)) {
          this.handleAuthError()
        } else {
          alert(err.message || '加载失败')
        }
      } finally {
        this.loading = false
      }
    },

    loadPage(page) {
      if (page >= 1 && page <= this.pagination.last_page) {
        this.loadList(page)
      }
    },

    goToFiles(spaceId) {
      this.$router.push({
        name: 'cloud-drive-files',
        params: { spaceId }
      })
    },

    formatDate(dateStr) {
      if (!dateStr) return ''
      return dateStr.split(' ')[0]
    }
  }
}
</script>

<style scoped>
.cloud-drive-list {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.header {
  margin-bottom: 30px;
}

.header h1 {
  font-size: 28px;
  color: #333;
}

.loading,
.empty {
  text-align: center;
  padding: 60px 20px;
  color: #999;
}

.drive-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.drive-card {
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.3s;
}

.drive-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.drive-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.drive-card h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #333;
}

.description {
  color: #666;
  font-size: 14px;
  margin-bottom: 12px;
  line-height: 1.5;
  min-height: 42px;
}

.meta {
  font-size: 12px;
  color: #999;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 30px;
}

.pagination button {
  padding: 8px 16px;
  border: 1px solid #d9d9d9;
  background: white;
  border-radius: 4px;
  cursor: pointer;
}

.pagination button:hover:not(:disabled) {
  border-color: #1890ff;
  color: #1890ff;
}

.pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
